<template>
  <el-scrollbar class="hide-x h-100">
    <div  id="cateMenu">
      <div v-for="(item, index) in menuList" :key="index" class="menu-item" :class="{'is-open': item.isOpen, 'is-parent-active': chooseMenuId === item.id}">
        <div class="flex align-center pl-20 menu-body" @click="onClickMenu(item, index)">
          <div class="index-tip">{{index + 1}}</div>
          <div class="menu-title-big" v-if="specialItem === 1">{{item.name + ' ' +item.specialItem}}</div>
          <div class="menu-title-big" v-else>
            {{item.name}}
          </div>
          <div class="btn-container" v-if="!notOperate">
            <i class="el-icon-circle-plus-outline mr-5" v-if="!notAdd" @click.stop="onAdd(item)"></i>
            <i class="el-icon-edit mr-5" v-if="!notEdit" @click.stop="onEdit(item)"></i>
            <div v-if="!cateType"><i class="el-icon-circle-close" v-if="!notDelete" @click.stop="onDelete(item)"></i></div>
            <div v-else>
              <i class="el-icon-circle-close" v-if="!notDelete && cateType == 1 && permission.includes('deleteMaterialClassify')" @click.stop="onDelete(item)"></i>
              <i class="el-icon-circle-close" v-if="!notDelete && cateType == 2 && permission.includes('deleteQuotaClassify')" @click.stop="onDelete(item)"></i>
              <i class="el-icon-circle-close" v-if="!notDelete && cateType == 3 && permission.includes('deleteBusinessClassify')" @click.stop="onDelete(item)"></i>
            </div>
          </div>
        </div>
        <template v-if="item.children && item.children.length">
          <!-- step固定为2 -->
          <cate-child-menu :not-operate="notOperate" :isReport="isReport" :specialItem=specialItem :permission="permission" :cateType="cateType" :not-add="notAdd" :step="2" v-show="item.isOpen" v-for="(child, idx) in item.children" :key="idx" :menu-info="child" :choose-id="chooseMenuId"  @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" @on-add="onAdd" ></cate-child-menu>
        </template>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
import CateChildMenu from './CateChildMenu'
export default {
  name: 'CateMenu',
  components: {CateChildMenu},
  props: ['menuData', 'chooseId', 'notOperate', 'notAdd', 'notEdit', 'notDelete', 'specialItem', 'permission', 'cateType', 'isReport'], // cateType 1 材料 2定额 3供应商 isReport 决策中心报表
  watch: {
    chooseId (newV, oldV) {
      this.chooseMenuId = newV
    }
  },
  data () {
    return {
      menuList: this.menuData,
      chooseMenuId: this.chooseId
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    onClickMenu (menu, index) {
      if (menu.children && menu.children.length) {
        menu.isOpen = !menu.isOpen
        this.$set(this.menuList, index, menu)
      }
      this.onChooseMenu(menu, index)
    },
    onChooseMenu (menu) {
      this.$emit('on-choose', menu)
    },
    onAdd (menu) {
      this.$emit('on-add', menu)
    },
    onDelete (menu) {
      this.$emit('on-delete', menu)
    },
    onEdit (menu) {
      this.$emit('on-edit', menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.hide-x {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
#cateMenu {
  height: 100%;
  width: 100%;
  min-width: 200px;
  background: #fff;
  overflow-y: auto;
  .menu-item {
    min-height: 35px;
    border-bottom: dashed 1px #e2e2e2;
    line-height: 35px;
    .index-tip {
      width: 20px;
      text-align: center;
      height: 14px;
      line-height: 14px;
      background-color: #b9b9b9;
      border-radius: 4px;
      font-size: 10px;
      color: #ffffff;
      margin-right: 5px;
    }
    .menu-title-big {
      flex: 1;
      overflow-x: hidden;
      font-size: 14px;
      color: #30313a;
      word-break: keep-all;
      text-align: left;
    }
    .btn-container {
      padding: 0 10px;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        color: #e2e2e2;
      }
    }
    &.is-open{
      background-color: #f3f4f7;
      .index-tip {
        background-color: #f5971d;
      }
      .menu-title-big {
        color: #f5971d;
      }
    }
    &.is-parent-active{
      .menu-body {
        background-color: #f5971d;
      }
      .index-tip {
        background-color: #ffffff;
        color: #f5971d;
      }
      .menu-title-big {
        color: #fff;
      }
    }
    .menu-body:hover, &.is-parent-active .menu-body {
      cursor: pointer;
      .btn-container {
        i {
          color: #30313a;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CateMenu.vue